import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";

import { smallScreen } from "src/shared/constants/screenSizes";

const CMSBannerWrapper = styled.div`
  @media screen and (max-width: ${smallScreen}px) {
    margin: 15px 0;
  }
`;

const ImageWrapper = styled.span`
  aspect-ratio: ${({ aspectRatio }) => aspectRatio};
  display: block;
`;

const Image = styled.img`
  display: block;
  width: 100%;
`;

const Separator = styled.div`
  background-color: ${colors.foxGrey};
  display: block;
  height: 1px;
  margin: 20px 0;

  @media screen and (max-width: ${smallScreen}px) {
    display: none;
  }
`;

const Link = styled.a``;

export { CMSBannerWrapper, Image, ImageWrapper, Link, Separator };
